import { render, staticRenderFns } from "./MFixedAssetEditor.yaml?vue&type=template&id=0581339e&component"
import script from "./MFixedAssetEditor.yaml?vue&type=script&lang=ts&component"
export * from "./MFixedAssetEditor.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports